import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Shell } from "./_shell";

export default function Expiring() {
  const [list, setList] = useState([]);
  const [days, setDays] = useState(30);
  const [loading, setLoading] = useState(true);
  const load = () => {
    setLoading(true);
    api.get(`/admin/expiring?days=${days}`).then(r => setList(r.data)).catch(() => setList([])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [days]);
  const colorFor = (s) => s === "expired" ? "text-soda border-soda" : s === "critical" ? "text-safety border-safety" : "text-cobalt border-cobalt";
  return (
    <Shell active="expiring">
      <div className="p-5 md:p-10">
        <div className="overline mb-2">Expiry alerts</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase leading-none mb-6">Expiring soon.</h1>
        <div className="flex items-center gap-3 mb-6">
          <label className="overline">Within</label>
          <select value={days} onChange={e => setDays(parseInt(e.target.value))} className="field max-w-[140px]" data-testid="expiring-window">
            <option value={7}>7 days</option>
            <option value={14}>14 days</option>
            <option value={30}>30 days</option>
            <option value={60}>60 days</option>
            <option value={90}>90 days</option>
          </select>
          <span className="text-sm text-black/60">{loading ? "Loading…" : `${list.length} product(s)`}</span>
        </div>
        <div className="border border-ink overflow-x-auto" data-testid="expiring-table">
          <table className="w-full text-sm min-w-[720px]">
            <thead>
              <tr className="border-b border-ink bg-ink text-paper">
                <th className="text-left p-3 overline">Status</th>
                <th className="text-left p-3 overline">Product</th>
                <th className="text-left p-3 overline">Batch</th>
                <th className="text-left p-3 overline">Stock</th>
                <th className="text-left p-3 overline">Expiry</th>
                <th className="text-left p-3 overline">Days</th>
              </tr>
            </thead>
            <tbody>
              {list.map(p => (
                <tr key={p.id} className="border-b border-black/10" data-testid={`expiring-${p.id}`}>
                  <td className="p-3"><span className={`chip text-[10px] ${colorFor(p.status)}`}>{p.status}</span></td>
                  <td className="p-3"><div className="font-bold">{p.name}</div><div className="text-[11px] text-black/60">{p.brand} · {p.sku || "—"}</div></td>
                  <td className="p-3 text-black/70">{p.batch_number || "—"}</td>
                  <td className="p-3 font-bold">{p.stock_quantity ?? "—"}</td>
                  <td className="p-3">{p.expiry_date}</td>
                  <td className={`p-3 font-bold ${p.days_left < 0 ? "text-soda" : p.days_left <= 7 ? "text-safety" : ""}`}>
                    {p.days_left < 0 ? `${Math.abs(p.days_left)} days ago` : `${p.days_left} days`}
                  </td>
                </tr>
              ))}
              {list.length === 0 && !loading && <tr><td colSpan="6" className="p-8 text-center text-black/50">Nothing expiring in the selected window — you're all clear.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Shell>
  );
}
